




















import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    TitleLine: require('@/components/TitleLine').default
  }
})
export default class FreeMonths extends Vue {
  get hasActiveSubscription() {
    return this.$store.state.subscription.active || this.$store.state.auth.isDemoUser
  }

  async created() {
    if (!this.hasActiveSubscription) {
      await this.$router.replace({
        name: 'dashboard'
      })
    }
  }
}
